import styles from "./CreateModal.module.css";

function CreateModal({ isOpen, onCreate, onClose }) {
    if (!isOpen) return null;

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        const cupao = { 
            coupon_code: formData.get("cupom"),
            discount_type: formData.get("type"),
            discount_value: formData.get("value"),
            max_uses: formData.get("maxuses") || null,
            expiration_date: formData.get("expdate") || null,
            applicable_services: formData.get("services") || null,
            exclusive_role: formData.get("roles") || null,
            first_purchase: formData.get("first") || 0,
            minimum_purchase_value: formData.get("minimum") || 0,
            partner: formData.get("partner") || 0
        };

        onCreate(cupao);
        onClose();
    };

    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>
                <h2>Criar Novo Cupão</h2>
                <form onSubmit={handleSubmit}>
                    <input name="cupom" placeholder="Código do Cupão *" required />
                    <input name="value" placeholder="Valor do Desconto *" type="number" step="0.01" required />
                    
                    <select name="type" placeholder="Tipo de Desconto *" required>
                        <option value="percentage">%</option>
                        <option value="fixed">R$</option>
                    </select>

                    <input name="maxuses" placeholder="Máximo de Usos" type="number" />
                    <input name="expdate" placeholder="Data de Expiração" type="date" />
                    <input name="services" placeholder="Serviços Aplicáveis" />

                    <select name="roles">
                        <option value="">Cargo Exclusivo</option>
                        <option value="Administrador">Administrador</option>
                        <option value="Gerente">Gerente</option>
                        <option value="Developer">Developer</option>
                        <option value="Suporte">Suporte</option>
                        <option value="Parceiro">Parceiro</option>
                        <option value="Cliente">Cliente</option>
                        <option value="Beta">Beta</option>
                        <option value="Booster">Booster</option>
                        <option value="Membro">Membro</option>
                    </select>

                    <select name="first">
                        <option value="">Primeira Compra?</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>

                    <input name="minimum" placeholder="Valor Mínimo (R$)" type="number" step="0.01" />

                    <select name="partner">
                        <option value="">Cupão de Parceiro?</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>

                    <div className={styles.buttons}>
                        <button className={styles.cancelButton} type="button" onClick={onClose}>Cancelar</button>
                        <button className={styles.confirmButton} type="submit">Criar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateModal;
